import "./productionBar.css";
const ProductionBar = (props)=>{

    let barWidth;
    let barCalc = (props.value * 100) / props.orderValue;
    
    if(barCalc > 100){
        barWidth = '100%';
    }else if(isNaN(barCalc)){
        barWidth = '0%';
    }else{
        barWidth = barCalc + '%';
    }
    
    return (
        <div className="pbContainer">
            <div className="pbValue">
                {props.value == null || props.value == undefined ? 0 : props.value} / {props.orderValue == null || props.orderValue == undefined ? 0 : props.orderValue}
            </div>
            <div className="pb" style={{width: barWidth}}>
                BAR
            </div>
        </div>
    )
}

export default ProductionBar;